<template>
  <footer id="site-footer" class="links:link-primary">
    <div class="footer-top color-light bg-footer-mascot py-12">
      <div class="container grid gap-8 text-center lg:grid-cols-3 lg:text-left">
        <SiteLogo />
        <SiteMenuFooter />
        <SiteFooterContact />
      </div>
    </div>
    <div class="footer-bottom dark color-dark py-8 text-base">
      <div class="container flex flex-col items-center justify-between gap-y-4 text-center 2xl:flex-row">
        <SiteFooterCopyright />
        <div class="sm:list-divided-x">
          <SiteFooterCredits />
          <div class="flex flex-col justify-center self-stretch">
            <AuthLink />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="postcss">
.bg-footer-mascot {
  @apply bg-[url(@/svg/mascot.svg)] bg-no-repeat;
  @apply bg-[length:53px_80px] bg-[bottom_right_2rem];
  @apply sm:bg-[length:106px_160px];
}
</style>
